import { useAuth } from "@/stores";

export const fetchWrapper = {
  get: request("GET"),
  getWithBlob: requestBlob("GET"), //EXCEL
  postWithBlob: requestBlob("POST"), //EXCEL
  getPdf: requestPDF("GET"), //PDF
  postPdf: requestPDF("POST"), //PDF
  post: request("POST"),
  postFiles: requestpostFiles("POST"),
  put: request("PUT"),
  delete: request("DELETE"),
  getPdfblob: requestPDFBlob("GET"), //PDF PARA ABRIR EN UNA PESTAÑA
  raw: requestRaw, // { ok, status, data }: no rechaza ni cierra sesión (heartbeat, cola offline, alertas)
};

function request(method) {
  return (url, body) => {
    const requestOptions = {
      method,
      headers: authHeader(url),
    };
    if (body) {
      requestOptions.headers["Content-Type"] = "application/json";
      requestOptions.body = JSON.stringify(body);
    }
    return fetch(url, requestOptions).then(handleResponse);
  };
}
function requestpostFiles(method) {
  return (url, body) => {
    const requestOptions = {
      method,
      headers: authHeader(url),
    };
    if (body) {
      //requestOptions.headers["Content-Type"] = "multipart/form-data;charset=utf-8; boundary=" + Math.random().toString().substr(2);
      requestOptions.body = body;
    }
    return fetch(url, requestOptions).then(handleResponse);
  };
}
function requestBlob(method) {
  return (url, body) => {
    const requestOptions = {
      method,
      headers: authHeader(url),
    };
    if (body) {
      requestOptions.headers["Content-Type"] = "application/json";
      requestOptions.body = JSON.stringify(body);
    }
    return fetch(url, requestOptions).then(handleResponseBlob);
  };
}
function requestPDF(method) {
  return (url, body) => {
    const requestOptions = {
      method,
      headers: authHeader(url),
    };
    if (body) {
      requestOptions.headers["Content-Type"] = "application/json";
      requestOptions.body = JSON.stringify(body);
    }
    return fetch(url, requestOptions).then(handleResponsePDF);
  };
}

/**
 * Variante para el modo offline: NUNCA rechaza y NUNCA llama a userLogout.
 * Devuelve { ok, status, data }; status 0 = sin respuesta (red caída, CORS o timeout).
 * opciones.timeoutMs: aborta la petición; opciones.auth = false: sin Authorization (para /ping).
 */
function requestRaw(method, url, body, opciones = {}) {
  const { timeoutMs = null, auth = true } = opciones;
  const requestOptions = {
    method,
    headers: auth ? authHeader(url) : { Accept: 'application/json' },
    cache: "no-store",
  };
  if (body) {
    requestOptions.headers["Content-Type"] = "application/json";
    requestOptions.body = JSON.stringify(body);
  }
  let temporizador = null;
  if (timeoutMs) {
    const controller = new AbortController();
    requestOptions.signal = controller.signal;
    temporizador = setTimeout(() => controller.abort(), timeoutMs);
  }
  const t0 = Date.now();
  const p0 = performance.now();
  return fetch(url, requestOptions)
    .then((response) => {
      // Etapa 3D (B): hora del servidor (cabecera Date, expuesta por CORS) y punto medio de la petición.
      // Date va en segundos enteros (truncados): +500 ms lleva al centro de ese segundo.
      const rttMs = performance.now() - p0;
      const fechaServidor = response.headers.get('Date');
      const reloj = fechaServidor ? { servidorMs: Date.parse(fechaServidor) + 500, equipoMs: t0 + rttMs / 2, rttMs } : null;
      return response.text().then((text) => {
        let data = null;
        try {
          data = text ? JSON.parse(text) : null;
        } catch (e) {
          data = text; // p. ej. la página HTML de un 502 del proxy
        }
        // Etapa 3D (B): antes return { ok: response.ok, status: response.status, data };
        return { ok: response.ok, status: response.status, data, reloj };
      });
    })
    .catch(() => ({ ok: false, status: 0, data: null }))
    .finally(() => clearTimeout(temporizador));
}

// helper functions

function authHeader(url) {
  // return auth header with jwt if user is logged in and request is to the api url
  const { token } = useAuth();

  const isLoggedIn = token.length > 0;
  const isApiUrl = url.startsWith(process.env.VUE_APP_ROOT_API);

  if (isLoggedIn && isApiUrl) {
    return { Authorization: `Bearer ${token}`, Accept: 'application/json' };
  } else {
    return { Accept: 'application/json' };
  }
}

function handleResponseBlob(response) {
    if(response.ok) {
    response.blob().then(function(miBlob) {
      /* var objectURL = URL.createObjectURL(miBlob);
      miImagen.src = objectURL; */
      var fileURL = window.URL.createObjectURL(new Blob([miBlob]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', new Date().toLocaleString().replace(/\D/g, "")+'.xlsx');
       document.body.appendChild(fileLink);
       fileLink.click();
    });
  } else {
    console.log('Respuesta de red OK pero respuesta HTTP no OK');
  }
}
function handleResponsePDF(response) {
    if(response.ok) {
    response.blob().then(function(miBlob) {
      /* var objectURL = URL.createObjectURL(miBlob);
      miImagen.src = objectURL; */
      var fileURL = window.URL.createObjectURL(new Blob([miBlob]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', new Date().toLocaleString().replace(/\D/g, "")+'.pdf');
       document.body.appendChild(fileLink);
       fileLink.click();
    });
  } else {
    console.log('Respuesta de red OK pero respuesta HTTP no OK');
  }
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      const { token, userLogout } = useAuth();
      if (response.status === 401 && token) {
        // 401: sesión vencida o token inválido -> cerrar sesión.
        // 403 es falta de permiso: no cierra sesión, rechaza con el message como los demás errores.
        userLogout();
      }

      if (response.status === 422 && data && data.errors) {
        const mensaje = data.message || Object.values(data.errors).flat().join(' ');
        return Promise.reject(mensaje);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

/**
 * Función para descargar el PDF como Blob sin forzar descarga
 */
function requestPDFBlob(method){  
  return (url) => {
    const requestOptions = { method, headers: authHeader(url) };
    return fetch(url, requestOptions).then(response => {
      if (response.ok) return response.blob();
      throw new Error('Error al obtener el PDF');
    });
  };
}
